module.exports = __webpack_public_path__ + "static/img/letterText.bddbcc33.png";